export function phraseFieldLabels(index) {
  if (typeof index !== "number" || !Number.isSafeInteger(index) || index < 0) {
    return null;
  }
  const number = index + 1;
  return {
    key: `Phrase key ${number}`,
    value: `Phrase value ${number}`,
    remove: `Remove phrase ${number}`,
  };
}
